export default {
  edit: { id: 'edit' },
  title: { id: 'title' },
  dateUpdated: { id: 'date_updated' },
  saveInfo: { id: 'save_info' },
  jobWorkflowTaskTranslation: { id: 'job_workflow_task_translation' },
  jobWorkflowTaskList: { id: 'job_workflow_task_list' },
  instructions: { id: 'instructions' },
}
